import script from "./NewsletterView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsletterView.vue?vue&type=script&setup=true&lang=js"

import "./NewsletterView.vue?vue&type=style&index=0&id=fee4b464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee4b464"]])

export default __exports__